import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { Register } from '../../_models/register';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-track-inbound-order',
  templateUrl: './track-inbound-order.component.html',
  styleUrls: ['./track-inbound-order.component.scss'],
})
export class TrackInboundOrderComponent implements OnInit {
  stockEntryHeader: any;
  getTrackOrderData: any;
  trackingNumber: any;
  shippingOption: any;
  order: any;
  getData: any = {};
  subject: any;
  customerSupport: boolean = false;
  description: any;
  displayCancelOrder: String = 'N';
  displayCustomerDisplay: String = 'N';
  displayCreateOrder: String = 'N';

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, public route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User, public register: Register) {
    this.getApi();
  }
  getApi() {
    this.g.loaderDisplay = "";
    this.api.getStockEntryHeadersAndLinesById(this.route.snapshot.params['id'], "", "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getData = data;
      this.shippingOption = data.shippingOption;
      this.trackingNumber = data.trackingNumberList;
      this.trackOrder();
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  displayRoute() {
    document.getElementById('div3').classList.add("d-none");
    document.getElementById('div4').classList.add("d-none");
    document.getElementById('div1').classList.remove("d-none");
  }
  cancelOrderDisplayDisplay() {
    document.getElementById('div1').classList.add("d-none");
    document.getElementById('div4').classList.add("d-none");
    document.getElementById('div3').classList.remove("d-none");
  }
  CustomerSupportDisplay() {
    document.getElementById('div1').classList.add("d-none");
    document.getElementById('div3').classList.add("d-none");
    document.getElementById('div4').classList.remove("d-none");
  }

  CSDisplay() {
    let x = document.getElementById("csorder");
    if (x.style.display === "none") {
      x.style.display = "block";
      this.customerSupport = true;
    } else {
      x.style.display = "none";
      this.customerSupport = false;
    }
  }
  ReturnOrder() {
    let x = document.getElementById("re-order");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }

  ngOnInit() {
  }
  trackOrder() {
    this.api.trackOrderForShiftAggregator(this.shippingOption, this.getData.id, this.getData.refType, this.trackingNumber).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getTrackOrderData = data.trackOrder;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }
  supportTicketCreate() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createSupportTicket', {
      "accountOwnerId": this.getData.accountOwnerId,
      "category": "Fulfilment Related",
      "description": this.description,
      "organizationId": this.user.organizationId,
      "subject": this.subject,
      "userId": this.user.userId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Ticket', 'Created Successfully');
          this.getApi();
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }
}

